<template>
  <div>
    <div class="sm:block">
      <div class="flex">
        <Page :title="pageTitle" class="w-full" isFullWidth>
          <template v-slot:action>
            <button
              class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
              type="button"
              @click="goToCreate"
              v-if="hasAccessToMarketing"
            >
              <span class="Polaris-Button__Content">
                <span class="Polaris-Button__Text">{{ actionLabel }}</span>
              </span>
            </button>
          </template>
          <div class="marketing-and-upsell-layout">
            <div class="layout-section">
              <div class="flex justify-between items-center"></div>
            </div>
            <div class="layout-section section-top-border">
              <div class="Polaris-Tabs__Outer">
                <div
                  class="Polaris-Box"
                  style="
                    --pc-box-padding-block-start-md: var(--p-space-200);
                    --pc-box-padding-block-end-md: var(--p-space-200);
                    --pc-box-padding-inline-start-md: var(--p-space-200);
                    --pc-box-padding-inline-end-md: var(--p-space-200);
                  "
                >
                  <div class="Polaris-Tabs__Wrapper">
                    <div class="Polaris-Tabs__ButtonWrapper">
                      <ul
                        class="Polaris-Tabs"
                        data-tabs-focus-catchment="true"
                        role="tablist"
                      >
                        <li
                          v-for="(tab, index) of tabs"
                          :key="index"
                          class="Polaris-Tabs__TabContainer"
                          role="presentation"
                        >
                          <router-link
                            :id="tab.routeName"
                            :class="[
                              'Polaris-Tabs__Tab',
                              {
                                'Polaris-Tabs__Tab--active': isTabActive(
                                  tab.routeName
                                )
                              }
                            ]"
                            :aria-label="tab.label"
                            role="tab"
                            :to="{ name: tab.routeName }"
                            :aria-controls="tab.routeName + '-content'"
                            :tabindex="isTabActive(tab.routeName) ? 0 : -1"
                            :aria-selected="isTabActive(tab.routeName)"
                          >
                            <div
                              class="Polaris-InlineStack"
                              style="
                                --pc-inline-stack-align: center;
                                --pc-inline-stack-block-align: center;
                                --pc-inline-stack-wrap: nowrap;
                                --pc-inline-stack-gap-xs: var(--p-space-200);
                                --pc-inline-stack-flex-direction-xs: row;
                              "
                            >
                              <span
                                class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                                >{{ tab.label }}</span
                              >
                            </div>
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="Polaris-Tabs__Panel w-full section-top-border"
              :id="$route.name + '-content'"
              role="tabpanel"
              :aria-labelledby="$route.name"
              tabindex="-1"
            >
              <div class="layout-section">
                <router-view></router-view>
              </div>
            </div>
          </div>
        </Page>
      </div>
    </div>
  </div>
</template>

<script>
import Page from "../components/Common/Page.vue";

// import Sidebar from "../components/Marketing/Sidebar.vue";

export default {
  components: {
    // Sidebar,
    Page
  },
  data() {
    return {
      pageTitle: "Marketing & Upsells",
      hasAccessToMarketing: false,
      isLoading: false,
      tabs: [
        {
          label: "Marketing",
          routeName: "Marketing"
        },
        {
          label: "Upsell",
          routeName: "Upsells"
        }
      ]
    };
  },
  computed: {
    isUpsellTab() {
      return !this.isMarketingTab;
    },
    isMarketingTab() {
      return [
        "Marketing",
        "Campaigns",
        "MarketingMessageLogs",
        "CreateCampaign",
        "CampaignDetail"
      ].includes(this.$route.name);
    },
    actionLabel() {
      return this.isMarketingTab ? "Send new campaign" : "Create new upsell";
    }
  },
  created() {
    const store = this.$store.getters.getStore;
    if (store.hasAccessToMarketing) {
      this.hasAccessToMarketing = true;
      return;
    }
    if (store.hasAccessToUpsell) {
      this.hasAccessToMarketing = true;
      return;
    }
  },
  methods: {
    isTabActive(routeName) {
      if (routeName === "Marketing") {
        return this.isMarketingTab;
      }
      if (routeName === "Upsells") {
        return this.isUpsellTab;
      }
      return false;
    },
    goToCreate() {
      if (this.isMarketingTab) {
        this.gotoNewCampaign();
      } else {
        this.gotoNewUpsell();
      }
    },
    gotoNewCampaign() {
      // Check eligibility before navigating to CreateCampaign
      this.isLoading = true;
      this.$store
        .dispatch("getMarketingEligiblity")
        .then((response) => {
          this.isLoading = false;
          if (response && response.needsOauth && response.authUrl) {
            open(response.authUrl, "_top");
            return;
          }
          if (response.needsUpdate) {
            this.usageCapUrl = response.url;
            this.showUsageChargeIncreaseModal = true;
          } else {
            this.$router.push({
              name: "CreateCampaign"
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
          alert("please contact support to send campaign");
        });
      return;
    },
    gotoNewUpsell() {
      // Check eligibility before navigating to CreateCampaign
      this.isLoading = true;
      this.$store
        .dispatch("getMarketingEligiblity")
        .then((response) => {
          this.isLoading = false;
          if (response && response.needsOauth && response.authUrl) {
            open(response.authUrl, "_top");
            return;
          }
          if (response.needsUpdate) {
            this.usageCapUrl = response.url;
            this.showUsageChargeIncreaseModal = true;
          } else {
            this.$router.push({
              name: "CreateUpsell"
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
          alert("please contact support to send campaign");
        });
      return;
    }
  }
};
</script>

<style lang="scss" scoped>
.marketing-and-upsell-layout {
  margin-top: 1rem;
}

.layout-section {
  padding: var(--p-space-400);
}

.section-top-border {
  border-top: 1px solid var(--p-color-border-secondary);
}
</style>
